import { ref, onMounted, onUnmounted, computed } from 'vue'


function useMediaQuery() {
    const xs = ref(false)
    const sm = ref(false)
    const md = ref(false)
    const lg = ref(false)
    const xl = ref(false)

    // xs: max-width: 575.98px
    getQueryFn("screen and (max-width: 575.98px)", 'xs', xs)()
    // sm: min-width: 576px and max-width: 767.98px
    getQueryFn("screen and (min-width: 576px) and (max-width: 767.98px)", 'sm', sm)()
    // md: min-width: 768px and max-width: 991.98px
    getQueryFn("screen and (min-width: 768px) and (max-width: 991.98px)", 'md', md)()
    // lg: min-width: 992px and max-width: 1199.98px
    getQueryFn("screen and (min-width: 992px) and (max-width: 1199.98px)", 'lg', lg)()
    // xl: min-width: 1200px
    getQueryFn("screen and (min-width: 1200px)", 'xl', xl)()
    return { xs, sm, md, lg, xl }
}

function getQueryFn(query, className, val) {

    function fn(x) {
        val.value = x.matches
    }

    const x = window.matchMedia(query)

    onMounted(() => x.addEventListener("change", fn))
    onUnmounted(() => x.removeEventListener("change", fn))

    return () => {
        fn(x)
    }

}


export {
    useMediaQuery,
}